<template>
  <div class="card border-dark card-kds">
    <div class="card-header p-2 bg-light d-flex">
      <div class="pointer" @click="selPedido()">
        <a class="mb-0 text-dark" href="javascript:">
          <b class="text-primary">#{{pedido.id_contador}}</b>
        </a>
        <div>
          <span class="badge badge-dark mr-1"><i class="fa fa-clock"></i> {{ pedido.tempo_pedido | timer }}</span>
          <span v-if="pedido.tipo_pedido === '1'" class="badge badge-success" title="Este pedido deverá ser entregue ao cliente">Entregar</span>
          <span v-else-if="pedido.tipo_pedido === '2'" class="badge badge-primary" title="Este pedido será retirado no estabelecimento">Retirar</span>
          <span v-else class="badge badge-warning" title="Este pedido será consumido no estabelecimento">Consumir</span>
        </div>
      </div>
      <button class="btn text-secondary ml-auto px-2" @click="imprimir()">
        <i class="fa fa-print"></i>
      </button>
    </div>
    <div class="card-footer bg-white p-2">
      <div v-if="pedido.status === '1'" class="">
        <button class="btn btn-success btn-block" @click="editarPedidos('2')">Iniciar</button>
      </div>
      <div v-else class="d-flex">
        <div class="w-50 mr-1"><button class="btn btn-primary btn-block" @click="editarPedidos('1')">Desfazer</button></div>
        <div class="w-50"><button class="btn btn-third btn-block" @click="editarPedidos('3')">Concluir</button></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KdsItem",
  props: ['pedido'],
  methods: {
    editarPedidos(status) {
      this.$emit('editar', this.pedido.id_pedido, status);
    },

    selPedido() {
      this.$emit('open', this.pedido.id_pedido);
    },

    imprimir() {
      this.$emit('imprimir', this.pedido.id_pedido);
    }
  },

  filters: {
    timer(time) {
      const hour = Math.floor((time || 0) / 60);
      const min = Math.floor(time - (hour * 60));
      return hour < 1 ? `${min}min` : (hour < 24 ? `${`0${hour}`.slice(-2)}` + ':' + `0${min}`.slice(-2) : `${hour}h`);
    }
  }
}
</script>

<style scoped>
.card-kds {
  margin: 8px 4px 4px;
  box-shadow: 0 1px 1px #091E4240, 0 0 1px #091E424F;
}
</style>